/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    loadClientIdGooglePay,
    clearClientIdGooglePay,
    useAnotherUserGooglePayAccount,
} from './GooglePay-Actions';

const initialState =         {
    changeAccount: false,
    clientToken: '',
};

const googlePayReducer = (state = initialState, action) => {
    switch (action.type) {
        case useAnotherUserGooglePayAccount().type:
            return {
                ...state,
                changeAccount: action.data,
            };
        case loadClientIdGooglePay().type:
            return {
                ...state,
                clientToken: action.data,
            };
        case clearClientIdGooglePay().type:
            return {
                ...state,
                clientToken: '',
            };
        default:
            return state;
    }
};

export default googlePayReducer;
